module.exports = __webpack_public_path__ + "static/media/reports.d1c2957e.svg";